import { useMemo, useState } from 'react';

import { Dimensions, Metrics, SortOrder, Sources } from 'components/insights/constants';
import { useInsightsContext } from 'components/insights/InsightsContainer';
import { getInitialDimensions } from 'components/insights/layout/details/helpers/dimensionsUtils';
import MetricBackArrow from 'components/insights/layout/details/MetricBackArrow';
import MetricDetailControlBar from 'components/insights/layout/details/MetricDetailControlBar';
import Separator from 'components/insights/layout/Separator';
import useAnalytics from 'components/insights/query/useAnalytics';

import ComparePriorPeriodToggle from '../ComparePriorPeriodToggle';

import ActivitiesPerPatientWeekChart from './ActivitiesPerPatientWeekChart';
import ActivitiesPerPatientWeekDataTable from './ActivitiesPerPatientWeekDataTable';

const ActivitiesPerPatientWeekDetail = () => {
  const { profile } = useInsightsContext();

  const [selectedDimensions, setSelectedDimensions] = useState<Dimensions[]>(
    getInitialDimensions(profile.canActAsManager)
  );

  const requestParams = useMemo(
    () => ({
      source: Sources.LOCATION_EPISODE_DAYS,
      dimensions: selectedDimensions,
      metrics: [
        Metrics.ACTIVITIES_PER_PATIENT_PER_WEEK,
        Metrics.LOCATION_EPISODE_ID_COUNT,
        Metrics.OWNER_ACTIVITIES_SUM,
      ],
      sortBy: `${Metrics.LOCATION_EPISODE_ID_COUNT} ${SortOrder.DESC}`,
      rollups: true,
    }),
    [selectedDimensions]
  );

  const analyticsResponse = useAnalytics(requestParams);

  return (
    <>
      <MetricDetailControlBar>
        <MetricBackArrow />
        <Separator height='20px' />
        <ComparePriorPeriodToggle />
      </MetricDetailControlBar>
      <ActivitiesPerPatientWeekChart
        {...analyticsResponse}
        onSelectedDimensionsChange={setSelectedDimensions}
        selectedDimensions={selectedDimensions}
      />
      <ActivitiesPerPatientWeekDataTable
        {...analyticsResponse}
        requestParams={requestParams}
        onSelectedDimensionsChange={setSelectedDimensions}
        selectedDimensions={selectedDimensions}
      />
    </>
  );
};

export default ActivitiesPerPatientWeekDetail;
